import axios from "axios";

const BACK_URL = import.meta.env.VITE_API_URL || "http://127.0.0.1:8000";

/**
 * Call /api/autocomplete/?q=... and return a flat array of tagged results.
 * Each item is tagged with a `type` field: "region" | "country" | "city" | "airport".
 *
 * Response shape (from the API):
 *   { regions: [...], countries: [...], cities: [...], airports: [...] }
 */
export async function flightAutocomplete({ q } = {}) {
  const query = (q ?? "").trim();
  if (!query) return [];

  const token = sessionStorage.getItem("charterplace.access") || "";

  const response = await axios.get(`${BACK_URL}/api/autocomplete/`, {
    params: { q: query },
    headers: {
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const data = response.data ?? {};
  return [
    ...(data.regions ?? []).map((r) => ({ ...r, type: "region" })),
    ...(data.countries ?? []).map((c) => ({ ...c, type: "country" })),
    ...(data.cities ?? []).map((c) => ({ ...c, type: "city" })),
    ...(data.airports ?? []).map((a) => ({ ...a, type: "airport" })),
  ];
}
